import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Breadcrumbs from 'Components/Utility/SEO/Breadcrumbs';
import messages from 'Components/FacetSearch/LanguagesStrings';

const FacetBreadcrumbs = ({
  facet,
  slug,
  name,
  subSlug,
  subName,
  page,
  parent,
  intl: { formatMessage },
}) => {
  const crumbs = [{
    label: formatMessage(messages.pcgames),
    link: '/all-games',
  }];

  if (facet) {
    crumbs.push({
      label: formatMessage(messages.all, { categoryPlural: formatMessage(messages[facet]) }),
      link: `/${facet}`,
    });
  }

  if (parent) {
    crumbs.push({
      label: parent.name,
      link: `/${facet}/${parent.slug}`,
    });
  }

  if (slug && name && !facet) {
    crumbs.push({
      label: name,
      link: `/${slug}`,
    });
  }

  if (slug && name && facet) {
    crumbs.push({
      label: name,
      link: `/${facet}/${slug}`,
    });
  }

  if (subSlug && subName && facet) {
    crumbs.push({
      label: subName,
      link: `/${facet}/${slug}/${subSlug}`,
    });
  }

  if (subSlug && subName && !facet) {
    crumbs.push({
      label: subName,
      link: `/${slug}/${subSlug}`,
    });
  }

  if (page > 1) {
    crumbs.push({
      label: `${formatMessage(messages.page)} ${page}`,
      link: `/${facet}/${slug}?page=${page}`,
    });
  }

  return <Breadcrumbs crumbs={crumbs} appearsOn={facet} />;
};

export default injectIntl(FacetBreadcrumbs);

FacetBreadcrumbs.propTypes = {
  facet: PropTypes.string,
  page: PropTypes.number,
  parent: PropTypes.shape({}),
  slug: PropTypes.string,
  name: PropTypes.string,
  subSlug: PropTypes.string,
  subName: PropTypes.string,
};

FacetBreadcrumbs.defaultProps = {
  facet: '',
  slug: '',
  parent: null,
  name: '',
  subSlug: '',
  subName: '',
  page: 1,
};
